var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke-current",
    fill: "none",
    height: 23,
    viewBox: "0 0 24 23",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.7808 10.1138c2.1656 0 3.9209-1.75533 3.9209-3.92092 0-2.16441-1.7553-3.92091-3.9209-3.92091",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.5837 14.375c.647.044 1.2892.1368 1.923.2771.8789.1748 1.9373.5351 2.3131 1.3236.2402.5054.2402 1.0941 0 1.5995-.3746.7885-1.4342 1.1488-2.3131 1.3296"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.13555 15.2192c4.38825 0 8.13675.6648 8.13675 3.3204 0 2.6567-3.7247 3.3441-8.13675 3.3441-4.38827 0-8.13555-.6636-8.13555-3.3203 0-2.6568 3.72349-3.3442 8.13555-3.3442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.13548 11.4284c-2.8946 0-5.2136-2.3202-5.2136-5.2148 0-2.8934 2.319-5.2136 5.2136-5.2136 2.89462 0 5.21482 2.3202 5.21482 5.2136 0 2.8946-2.3202 5.2148-5.21482 5.2148z",
    opacity: 0.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersSvg);
export default __webpack_public_path__ + "static/media/UsersSVG.9d5ce2d6.svg";
export { ForwardRef as ReactComponent };